$(function() {
    backToTop();
    whatsApp();

    $(window).on("scroll", function() {
        backToTop();
        whatsApp();
    });

    AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false
    });

    datepicker();

    if (typeof window.GLightbox === 'function') {
        window.GLightbox({
            selector: '.lightbox, .glightbox'
        });
    }

    if (window.location.hash) {
        let section = $(window.location.hash);
        if (!section) return false;
        scrollTo(section);
    }
});
